<script setup lang="ts">
import { defineProps, toRef } from "vue";
import { useGridGenerator } from "@/views/Calculators/ApartmentPlan/composables/useGridGenerator";
import { BoundingBox } from "@/types/stage";

const props = defineProps<{
  boundingBox: BoundingBox | null;
}>();

const boundingBoxRef = toRef(props, "boundingBox");

const { gridLines } = useGridGenerator(boundingBoxRef, 6, 5, "blue", "blue");
</script>

<template>
  <v-line
    v-for="(line, i) in gridLines"
    :key="'middle-mountains-grid-' + i"
    :config="line"
  />
</template>
